import { environmentBase, EnvironmentSettings } from './environment-base';

export const environment: EnvironmentSettings = {
  ... environmentBase,
  production: true,
  apiBaseUrl: '',
  apiConfig: {
    scopes: [],
    uri: ''
  },
   msalConfig: {
    auth: {
      clientId: 'b9fd5c37-74fe-40d7-ab98-01cf2eed9dc5',
      authority: 'https://login.microsoftonline.com/f5c71729-7816-4984-867a-0b3a69f99ff8',
    },
  },
};